<template>
    <v-container class="d-flex flex-column justify-center align-center container">

        <img class="img_initial contain align-self-center" src="../../../assets/logo-lateral.webp" alt="">

        <v-card width='200px' class="">

            <v-progress-linear color="primary" indeterminate rounded height="4"></v-progress-linear>

        </v-card>

    </v-container>
</template>

<script>

export default {

    name: 'SplashLoading'

}

</script>

<style scoped>

.img_initial {

    height: 100px;


}


@media all and (min-width: 1000px) {

    .img_initial {

        height: 160px;

    }
}

</style>